import React from "react";
import './Hero.css'
import heroimg from '../Assets/hero-img.png'

const Hero = () => {
    return(
        <div className="hero">
           <img src={heroimg} alt="" />
        </div>
    )
}

export default Hero